import { render, staticRenderFns } from "./ItinerariesPageItem.vue?vue&type=template&id=602101b2&scoped=true&"
import script from "./ItinerariesPageItem.vue?vue&type=script&lang=ts&"
export * from "./ItinerariesPageItem.vue?vue&type=script&lang=ts&"
import style0 from "./ItinerariesPageItem.vue?vue&type=style&index=0&id=602101b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602101b2",
  null
  
)

export default component.exports